import { EditorAssistance } from '../../../models/EditorAssistance'

export class EditorAssistanceBundle {
  main: EditorAssistance
  children: EditorAssistance[]
  selectedAssistanceIndex: number = 0

  constructor(
    mainAssistance: EditorAssistance,
    childAssistances: EditorAssistance[] = [],
    selectedAssistanceId?: number,
  ) {
    this.main = mainAssistance
    this.children = childAssistances
    if (selectedAssistanceId) {
      this.updateSelectedAssistanceIndex(selectedAssistanceId)
    }
  }

  get all() {
    return [this.main, ...this.children]
  }
  private updateSelectedAssistanceIndex(selectedAssistanceId: number) {
    const selectedAssistance = this.all.find((assistance) => assistance.id === selectedAssistanceId)
    if (selectedAssistance) {
      this.selectedAssistanceIndex = this.all.indexOf(selectedAssistance)
    }
  }
  get selectedAssistance(): EditorAssistance {
    return this.all[this.selectedAssistanceIndex] || this.main
  }
  get count(): number {
    return this.all.length
  }
  get assistanceIndex(): number {
    return this.selectedAssistanceIndex
  }
}
